// @flow
import React from 'react';
import styled from 'styled-components';
import type { HOC as ElementType } from 'recompose';
import { Container } from './../Container/Container';
import { Text1, Text2Normal, Button } from './../core';
import type { withTextIconType } from './../../types';
import { Space } from './../Space';
import { media } from './../../helpers/media';

const LikeText = styled(Text1)`
  ${media.aboveMobile`
    font-size: var(--text-sm);
    line-height: 20px;
    letter-spacing: -0.16px;
    color: var(--color-grey-4);
  `};
`;

export const renderItemLikes = (likes: number) => () => (
  <LikeText color="black-3">{likes}</LikeText>
);

const Wrapper = styled(Button.withComponent(Container))`
  text-align: center;
  width: ${({ width = '50' }) => (width === 'auto' ? 'auto' : `${width}px`)};
`;

const defaultRenderText = (outline: boolean, text: string) => (
  <Text2Normal outline={outline}>{text}</Text2Normal>
);

export const withTextIcon = (Comp: ElementType) => ({
  radius,
  text,
  onClick,
  outline,
  renderText = defaultRenderText,
  ...props
}: withTextIconType) => (
  <Wrapper flexColumn align="center" width={radius} onClick={onClick}>
    <Comp {...props} radius={radius} outline={outline} />
    {renderText(outline, text)}
  </Wrapper>
);

export const withRowTextIcon = (Comp: ElementType) => ({
  radius,
  text,
  onClick,
  outline,
  renderText = defaultRenderText,
  ...props
}: withTextIconType) => (
  <Container align="center">
    <Wrapper width={radius} onClick={onClick}>
      <Comp {...props} radius={radius} outline={outline} />
    </Wrapper>
    <Space mr="2" />
    {renderText(outline, text)}
  </Container>
);
